/**
 * Должен совпадать с Verbum.Domain.Chat.ChatStreamMode (C#).
 * В Telegram в UI нет Application (1); на вебе в UI обычно нет Deep (4).
 */
export const ChatStreamMode = Object.freeze({
  Question: 0,
  Application: 1,
  KeyIdea: 2,
  Example: 3,
  Deep: 4,
  Simple: 5,
  Faq: 6,
  VerseExplain: 7,
});
